import Vue from 'vue'
import VueRouter from 'vue-router'
import Schedule from '../views/Schedule.vue'
import Resources from '../views/Resources.vue'
import Results from '../views/Results.vue'
import Register from '../views/Register.vue'
import Login from '../views/Login.vue'
import Officials from '../views/Officials.vue'
import InsertResults from '../views/InsertResults.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Schedule',
    component: Schedule
  },
  {
    path: '/results/:date*',
    name: 'Results',
    component: Results
  },
  {
    path: '/resources',
    name: 'Resources',
    component: Resources
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/officials',
    name: 'Officials',
    component: Officials
  },
  {
    path: '/scores',
    name: 'Insert Results',
    component: InsertResults
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
console.log(process.env.BASE_URL);
export default router
